import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import mainLogo from "../../Images/GRC-Pulse-Logo.png";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenServices, setIsOpenServices] = useState(false);
  const [isOpenEcommerce, setIsOpenEcommerce] = useState(false);
  const { pathname } = useLocation();
  const [servicesAnchorEl, setServicesAnchorEl] = useState(null);
  const [ecommerceAnchorEl, setEcommerceAnchorEl] = useState(null);

  const handleServicesClick = (event) => {
    setServicesAnchorEl(event.currentTarget);
  };
  const handleEcommerceClick = (event) => {
    setEcommerceAnchorEl(event.currentTarget);
  };

  const handleServicesClose = () => {
    setServicesAnchorEl(null);
  };
  const handleEcommerceClose = () => {
    setEcommerceAnchorEl(null);
  };

  return (
    <nav className="px-4 z-50 py-3 position-fixed w-100" style={{ backgroundColor: "rgba(0,0,0,0.85)" }}>
      <div className="flex items-center justify-between">
        <Link to="/">
          <img src={mainLogo} alt="Logo" className="w-[110px] h-[40px]" />
        </Link>

        <div className="hidden md:flex space-x-6 items-center">
          <Link to="/" className={pathname === "/" ? "block text-slate-50 border-b-2 border-white" : "block text-slate-50"}>Home</Link>
          <Link to="/about-us" className={pathname === "/about-us" ? "block text-slate-50 border-b-2 border-white" : "block text-slate-50"}>About</Link>

          <div
            onClick={handleServicesClick}
            className={pathname.includes("/services") ? "block text-slate-50 border-b-2 border-white flex gap-2 items-center cursor-pointer" : "block text-slate-50 flex gap-2 items-center cursor-pointer"}
          >
            <h1>Services</h1>
            <IoIosArrowDown />
          </div>

          <Menu
            anchorEl={servicesAnchorEl}
            open={Boolean(servicesAnchorEl)}
            onClose={handleServicesClose}
            MenuListProps={{ 'aria-labelledby': 'services-button' }}
          >
            <MenuItem onClick={handleServicesClose}><Link to="/services/establishment-compliance">Establishment Compliance</Link></MenuItem>
            <MenuItem onClick={handleServicesClose}><Link to="/services/vendor-compliance">Vendor Compliance</Link></MenuItem>
            <MenuItem onClick={handleServicesClose}><Link to="/services/factory-compliance">Factory Compliance</Link></MenuItem>
            <MenuItem onClick={handleServicesClose}><Link to="/services/registration">Licenses And Registration</Link></MenuItem>
            <MenuItem onClick={handleServicesClose}><Link to="/services/payroll-management">Payroll Management</Link></MenuItem>
            <MenuItem onClick={handleServicesClose}><Link to="/services/new-labour-laws">New Labour Codes</Link></MenuItem>
            <MenuItem onClick={handleServicesClose}><Link to="/services/productivity-audit">Productivity Audit</Link></MenuItem>
            <MenuItem onClick={handleServicesClose}><Link to="/services/hr-service-provider-audit">HR Service Provider Audit</Link></MenuItem>
          </Menu>

          <div
            onClick={handleEcommerceClick}
            className="block text-slate-50 flex gap-2 items-center cursor-pointer"
          >
            <h1>e-Library</h1>
            <IoIosArrowDown />
          </div>

          <Menu
            anchorEl={ecommerceAnchorEl}
            open={Boolean(ecommerceAnchorEl)}
            onClose={handleEcommerceClose}
            MenuListProps={{ 'aria-labelledby': 'ecommerce-button' }}
          >
            <MenuItem onClick={handleEcommerceClose}><Link to="/minimum-wages/view">Minimum Wages</Link></MenuItem>
            <MenuItem onClick={handleEcommerceClose}><Link to="/hoilday-list">Holiday List</Link></MenuItem>
            {/* <MenuItem onClick={handleEcommerceClose}><Link to="/professional-tax">Professional Tax</Link></MenuItem> */}
            {/* <MenuItem onClick={handleEcommerceClose}><Link to="/labour-welfare-fund">Labour Welfare Fund</Link></MenuItem> */}
          </Menu>

          <Link to="/contact-us" className={pathname === "/contact-us" ? "block text-slate-50 border-b-2 border-white" : "block text-slate-50"}>Contact Us</Link>

          <button className="bg-primary-color font-bold p-2 text-white rounded-md border border-white">
            <Link to="/signin">Login</Link>
          </button>
        </div>

        <button className="text-white md:hidden" onClick={() => setIsOpen(!isOpen)}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {isOpen && (
        <div className="md:hidden bg-blue-700">
          <Link to="/" className="block px-4 py-2 text-white">Home</Link>
          <Link to="/about-us" className="block px-4 py-2 text-white">About</Link>

          <div className="relative">
            <button onClick={() => setIsOpenServices(!isOpenServices)} className="block w-full px-4 py-2 text-white flex justify-between">
              Services <IoIosArrowDown />
            </button>
            {isOpenServices && (
              <div className="bg-blue-600">
                <Link to="/services/establishment-compliance" className="block px-4 py-2 text-white">Establishment Compliance</Link>
                <Link to="/services/vendor-compliance" className="block px-4 py-2 text-white">Vendor Compliance</Link>
                <Link to="/services/factory-compliance" className="block px-4 py-2 text-white">Factory Compliance</Link>
                <Link to="/services/registration" className="block px-4 py-2 text-white">Licenses And Registration</Link>
                <Link to="/services/payroll-management" className="block px-4 py-2 text-white">Payroll Management</Link>
                <Link to="/services/new-labour-laws" className="block px-4 py-2 text-white">New Labour Codes</Link>
                <Link to="/services/productivity-audit" className="block px-4 py-2 text-white">Productivity Audit</Link>
                <Link to="/services/hr-service-provider-audit" className="block px-4 py-2 text-white">HR Service Provider Audit</Link>
              </div>
            )}
          </div>

          <div className="relative">
            <button onClick={() => setIsOpenEcommerce(!isOpenEcommerce)} className="block w-full px-4 py-2 text-white flex justify-between">
              e-Library <IoIosArrowDown />
            </button>
            {isOpenEcommerce && (
              <div className="bg-blue-600">
                <Link to="/minimum-wages" className="block px-4 py-2 text-white">Minimum Wages</Link>
                <Link to="/hoilday-list" className="block px-4 py-2 text-white">Holiday List</Link>
                <Link to="/professional-tax" className="block px-4 py-2 text-white">Professional Tax</Link>
                <Link to="/labour-welfare-fund" className="block px-4 py-2 text-white">Labour Welfare Fund</Link>
              </div>
            )}
          </div>

          <Link to="/contact-us" className="block px-4 py-2 text-white">Contact</Link>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
